"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldToJSON = exports.FieldToJSONJoined = exports.FieldFromJSONTyped = exports.FieldFromJSON = exports.instanceOfField = exports.FieldTypeEnum = exports.attributeTypeMapField = void 0;
var FieldIntegrationMetadata_1 = require("./FieldIntegrationMetadata");
var CheckboxField_1 = require("./CheckboxField");
var DateField_1 = require("./DateField");
var DropdownField_1 = require("./DropdownField");
var HyperlinkField_1 = require("./HyperlinkField");
var ImageField_1 = require("./ImageField");
var InitialsField_1 = require("./InitialsField");
var RadioButtonField_1 = require("./RadioButtonField");
var RectangleField_1 = require("./RectangleField");
var SignatureField_1 = require("./SignatureField");
var TextField_1 = require("./TextField");
exports.attributeTypeMapField = [
    {
        name: "type",
        type: "string",
    },
    {
        name: "id",
        type: "string",
    },
    {
        name: "pageIndex",
        type: "number",
    },
    {
        name: "x",
        type: "number",
    },
    {
        name: "y",
        type: "number",
    },
    {
        name: "signer",
        type: "string",
    },
    {
        name: "width",
        type: "number",
    },
    {
        name: "height",
        type: "number",
    },
    {
        name: "documentId",
        type: "string",
    },
    {
        name: "apiId",
        type: "string",
    },
    {
        name: "invalidApiId",
        type: "string",
    },
    {
        name: "name",
        type: "string",
    },
    {
        name: "required",
        type: "boolean",
    },
    {
        name: "originalRequired",
        type: "boolean",
    },
    {
        name: "hidden",
        type: "boolean",
    },
    {
        name: "readOnly",
        type: "boolean",
    },
    {
        name: "linkId",
        type: "string",
    },
    {
        name: "integrationMetadata",
        type: "FieldIntegrationMetadata",
    },
];
/**
 * @export
 */
exports.FieldTypeEnum = {
    Checkbox: "checkbox",
    Date: "date",
    Text: "text",
    Dropdown: "dropdown",
    Image: "image",
    Initials: "initials",
    Radiobutton: "radiobutton",
    Rectangle: "rectangle",
    Signature: "signature",
    Hyperlink: "hyperlink",
};
/**
 * Check if a given object implements the Field interface.
 */
function instanceOfField(value) {
    if (!("type" in value) || value["type"] === undefined)
        return false;
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("pageIndex" in value) || value["pageIndex"] === undefined)
        return false;
    if (!("x" in value) || value["x"] === undefined)
        return false;
    if (!("y" in value) || value["y"] === undefined)
        return false;
    if (!("signer" in value) || value["signer"] === undefined)
        return false;
    if (!("width" in value) || value["width"] === undefined)
        return false;
    if (!("height" in value) || value["height"] === undefined)
        return false;
    if (!("documentId" in value) || value["documentId"] === undefined)
        return false;
    return true;
}
exports.instanceOfField = instanceOfField;
function FieldFromJSON(json) {
    return FieldFromJSONTyped(json, false);
}
exports.FieldFromJSON = FieldFromJSON;
function FieldFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json["type"] === "checkbox") {
            return (0, CheckboxField_1.CheckboxFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "date") {
            return (0, DateField_1.DateFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "dropdown") {
            return (0, DropdownField_1.DropdownFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "hyperlink") {
            return (0, HyperlinkField_1.HyperlinkFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "image") {
            return (0, ImageField_1.ImageFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "initials") {
            return (0, InitialsField_1.InitialsFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "radiobutton") {
            return (0, RadioButtonField_1.RadioButtonFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "rectangle") {
            return (0, RectangleField_1.RectangleFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "signature") {
            return (0, SignatureField_1.SignatureFieldFromJSONTyped)(json, true);
        }
        if (json["type"] === "text") {
            return (0, TextField_1.TextFieldFromJSONTyped)(json, true);
        }
    }
    return {
        type: json["type"],
        id: json["id"],
        pageIndex: json["pageIndex"],
        x: json["x"],
        y: json["y"],
        signer: json["signer"],
        width: json["width"],
        height: json["height"],
        documentId: json["documentId"],
        apiId: json["apiId"] == null ? undefined : json["apiId"],
        invalidApiId: json["invalidApiId"] == null ? undefined : json["invalidApiId"],
        name: json["name"] == null ? undefined : json["name"],
        required: json["required"] == null ? undefined : json["required"],
        originalRequired: json["originalRequired"] == null ? undefined : json["originalRequired"],
        hidden: json["hidden"] == null ? undefined : json["hidden"],
        readOnly: json["readOnly"] == null ? undefined : json["readOnly"],
        linkId: json["linkId"] == null ? undefined : json["linkId"],
        integrationMetadata: json["integrationMetadata"] == null
            ? undefined
            : (0, FieldIntegrationMetadata_1.FieldIntegrationMetadataFromJSON)(json["integrationMetadata"]),
    };
}
exports.FieldFromJSONTyped = FieldFromJSONTyped;
function FieldToJSONJoined(value) {
    if (value == null) {
        return value;
    }
    if (value["type"] === "checkbox") {
        return (0, CheckboxField_1.CheckboxFieldToJSON)(value);
    }
    if (value["type"] === "date") {
        return (0, DateField_1.DateFieldToJSON)(value);
    }
    if (value["type"] === "dropdown") {
        return (0, DropdownField_1.DropdownFieldToJSON)(value);
    }
    if (value["type"] === "hyperlink") {
        return (0, HyperlinkField_1.HyperlinkFieldToJSON)(value);
    }
    if (value["type"] === "image") {
        return (0, ImageField_1.ImageFieldToJSON)(value);
    }
    if (value["type"] === "initials") {
        return (0, InitialsField_1.InitialsFieldToJSON)(value);
    }
    if (value["type"] === "radiobutton") {
        return (0, RadioButtonField_1.RadioButtonFieldToJSON)(value);
    }
    if (value["type"] === "rectangle") {
        return (0, RectangleField_1.RectangleFieldToJSON)(value);
    }
    if (value["type"] === "signature") {
        return (0, SignatureField_1.SignatureFieldToJSON)(value);
    }
    if (value["type"] === "text") {
        return (0, TextField_1.TextFieldToJSON)(value);
    }
}
exports.FieldToJSONJoined = FieldToJSONJoined;
function FieldToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        type: value["type"],
        id: value["id"],
        pageIndex: value["pageIndex"],
        x: value["x"],
        y: value["y"],
        signer: value["signer"],
        width: value["width"],
        height: value["height"],
        documentId: value["documentId"],
        apiId: value["apiId"],
        invalidApiId: value["invalidApiId"],
        name: value["name"],
        required: value["required"],
        originalRequired: value["originalRequired"],
        hidden: value["hidden"],
        readOnly: value["readOnly"],
        linkId: value["linkId"],
        integrationMetadata: (0, FieldIntegrationMetadata_1.FieldIntegrationMetadataToJSON)(value["integrationMetadata"]),
    };
}
exports.FieldToJSON = FieldToJSON;
